var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[{ isActive: _vm.active }, _vm.icon],attrs:{"to":_vm.to}},[_c(require(("@/assets/icons/" + _vm.icon + ".svg")),{tag:"component"}),_c('p',{staticClass:"copy w-bold"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }